import { CategoryPage } from "@outschool/gql-backend-generated";
import {
  QueryHookOptions,
  useQueryWithPreviousData
} from "@outschool/ui-apollo";

import { CategoryPageQuery as CategoryPageQueryV2 } from "../queries/CategoryPageQuery";

export const useCategoryPageQuery = (
  slug?: string,
  options?: QueryHookOptions
) =>
  useQueryWithPreviousData<{
    categoryPage: CategoryPage;
  }>(CategoryPageQueryV2, {
    variables: { slug },
    ...{ ...options, skip: !slug }
  });
